export const baseUrl = 'https://xinwc.cn';
// export const baseUrl = 'https://dev.hyzszy.com.cn/';
